
import service from "../services/metrics.service";

export const metrics = {
    namespaced: true,
    state: {
        summary: null,
        monthlyComparison: null,
        weeklyBreakdown: null,
        dailyBreakdown: null,
        yearlyComparison: null,
        technicianTracking: null,
        customerRepurchase: null,
        oilChangeReminders: null,
        inventoryTracking: null,
        partsBalance: null,
        laborByService: null,
    },
    getters: {
        summary: (state) => state.summary,
        monthlyComparison: (state) => state.monthlyComparison,
        weeklyBreakdown: (state) => state.weeklyBreakdown,
        dailyBreakdown: (state) => state.dailyBreakdown,
        yearlyComparison: (state) => state.yearlyComparison,
        technicianTracking: (state) => state.technicianTracking,
        customerRepurchase: (state) => state.customerRepurchase,
        oilChangeReminders: (state) => state.oilChangeReminders,
        inventoryTracking: (state) => state.inventoryTracking,
        partsBalance: (state) => state.partsBalance,
        laborByService: (state) => state.laborByService,
    },
    actions: {
        async getSummary({ commit }, params = {}) {
            try {
                const response = await service.getSummary(params);
                commit('SET_SUMMARY', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching metrics summary:", error);
                throw error.response;
            }
        },
        async getMonthlyComparison({ commit }, params = {}) {
            try {
                const response = await service.getMonthlyComparison(params);
                commit('SET_MONTHLY_COMPARISON', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching monthly comparison:", error);
                throw error.response;
            }
        },
        async getWeeklyBreakdown({ commit }, params = {}) {
            try {
                const response = await service.getWeeklyBreakdown(params);
                commit('SET_WEEKLY_BREAKDOWN', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching weekly breakdown:", error);
                throw error.response;
            }
        },
        async getDailyBreakdown({ commit }, params = {}) {
            try {
                const response = await service.getDailyBreakdown(params);
                commit('SET_DAILY_BREAKDOWN', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching daily breakdown:", error);
                throw error.response;
            }
        },
        async getYearlyComparison({ commit }, params = {}) {
            try {
                const response = await service.getYearlyComparison(params);
                commit('SET_YEARLY_COMPARISON', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching yearly comparison:", error);
                throw error.response;
            }
        },
        async getTechnicianTracking({ commit }, params = {}) {
            try {
                const response = await service.getTechnicianTracking(params);
                commit('SET_TECHNICIAN_TRACKING', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching technician tracking:", error);
                throw error.response;
            }
        },
        async getCustomerRepurchase({ commit }, params = {}) {
            try {
                const response = await service.getCustomerRepurchase(params);
                commit('SET_CUSTOMER_REPURCHASE', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching customer repurchase:", error);
                throw error.response;
            }
        },
        async getOilChangeReminders({ commit }, params = {}) {
            try {
                const response = await service.getOilChangeReminders(params);
                commit('SET_OIL_CHANGE_REMINDERS', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching oil change reminders:", error);
                throw error.response;
            }
        },
        async getInventoryTracking({ commit }, params = {}) {
            try {
                const response = await service.getInventoryTracking(params);
                commit('SET_INVENTORY_TRACKING', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching inventory tracking:", error);
                throw error.response;
            }
        },
        async getPartsBalance({ commit }, params = {}) {
            try {
                const response = await service.getPartsBalance(params);
                commit('SET_PARTS_BALANCE', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching parts balance:", error);
                throw error.response;
            }
        },
        async getLaborByService({ commit }, params = {}) {
            try {
                const response = await service.getLaborByService(params);
                commit('SET_LABOR_BY_SERVICE', response.data);
                return response;
            } catch (error) {
                console.error("Error fetching labor by service:", error);
                throw error.response;
            }
        },
    },
    mutations: {
        SET_SUMMARY(state, data) {
            state.summary = data;
        },
        SET_MONTHLY_COMPARISON(state, data) {
            state.monthlyComparison = data;
        },
        SET_WEEKLY_BREAKDOWN(state, data) {
            state.weeklyBreakdown = data;
        },
        SET_DAILY_BREAKDOWN(state, data) {
            state.dailyBreakdown = data;
        },
        SET_YEARLY_COMPARISON(state, data) {
            state.yearlyComparison = data;
        },
        SET_TECHNICIAN_TRACKING(state, data) {
            state.technicianTracking = data;
        },
        SET_CUSTOMER_REPURCHASE(state, data) {
            state.customerRepurchase = data;
        },
        SET_OIL_CHANGE_REMINDERS(state, data) {
            state.oilChangeReminders = data;
        },
        SET_INVENTORY_TRACKING(state, data) {
            state.inventoryTracking = data;
        },
        SET_PARTS_BALANCE(state, data) {
            state.partsBalance = data;
        },
        SET_LABOR_BY_SERVICE(state, data) {
            state.laborByService = data;
        },
    },
};
